var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconTrandeExchange = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "icon_trande_exchange")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bswap",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tool_PCX-transfer",
    transform: "translate(-407, -276)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-4",
    transform: "translate(175, 134.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_trande_exchange",
    transform: "translate(240, 149.5) rotate(-270) translate(-240, -149.5)translate(232, 141.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#D8D8D8",
    opacity: 0,
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.69273129,0.218432639 C4.75106673,0.264988278 4.80400682,0.317928362 4.85056246,0.376263802 L8.13791504,4.49540301 L5.068,4.495 L5.06895752,12.32777 C5.06895752,12.8800547 4.62124227,13.32777 4.06895752,13.32777 C3.51667277,13.32777 3.06895752,12.8800547 3.06895752,12.32777 L3.068,4.495 L0,4.49540301 L3.28735258,0.376263802 C3.63185332,-0.0554046852 4.26106281,-0.126068104 4.69273129,0.218432639 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "#281071"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5548163,2.89066269 C12.6131517,2.93721833 12.6660918,2.99015841 12.7126474,3.04849385 L16,7.16763306 L12.930085,7.16712231 L12.9310425,15 C12.9310425,15.5522847 12.4833272,16 11.9310425,16 C11.3787577,16 10.9310425,15.5522847 10.9310425,15 L10.930085,7.16712231 L7.86208496,7.16763306 L11.1494375,3.04849385 C11.4939383,2.61682536 12.1231478,2.54616194 12.5548163,2.89066269 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "#281071",
    transform: "translate(11.931, 9.0346) scale(1, -1) translate(-11.931, -9.0346)"
  }))))))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconTrandeExchange, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_trande_exchange.d5a9b9a9.svg";
export { ForwardRef as ReactComponent };